import HttpV2 from './HttpV2';

class XmlImportLogServiceV2 {
  static async getLogs(payload = {}) {
    return HttpV2.get('admin/xml-import-logs', {params: payload});
  }

  static async getClientNames() {
    return HttpV2.get('admin/xml-import-logs/clients');
  }
}

export default XmlImportLogServiceV2;
